import type { CSSProperties } from 'react';

import type { DialogPassThroughOptions } from 'primereact/dialog';

const BASE = 'dialog-footer-actions';
const DEPARTMENT = 'dialog-footer-actions--department';

export type DialogFooterSpacingOptions = {
  department?: boolean;
  footerPaddingTop?: string | number;
};

function footerClassName(department?: boolean): string {
  return department ? `${BASE} ${DEPARTMENT}` : BASE;
}

function toPaddingTop(value: string | number): string {
  return typeof value === 'number' ? `${value}px` : value;
}

function mergeFooterPt(
  className: string,
  footerPaddingTop: string | number | undefined,
  prevFooter: DialogPassThroughOptions['footer']
): NonNullable<DialogPassThroughOptions['footer']> {
  const stylePatch: CSSProperties = {};
  if (footerPaddingTop !== undefined && footerPaddingTop !== '') {
    stylePatch.paddingTop = toPaddingTop(footerPaddingTop);
  }

  if (
    prevFooter &&
    typeof prevFooter === 'object' &&
    !Array.isArray(prevFooter)
  ) {
    const prev = prevFooter as {
      className?: string;
      style?: CSSProperties;
    };
    const mergedClass = [className, prev.className].filter(Boolean).join(' ').trim();
    const mergedStyle =
      Object.keys(stylePatch).length > 0
        ? { ...prev.style, ...stylePatch }
        : prev.style;
    return {
      ...prev,
      className: mergedClass,
      ...(mergedStyle && Object.keys(mergedStyle).length > 0
        ? { style: mergedStyle }
        : {})
    };
  }

  if (Object.keys(stylePatch).length === 0) {
    return { className };
  }

  return { className, style: stylePatch };
}

export function withDialogFooterSpacing(
  pt?: DialogPassThroughOptions | null,
  options?: DialogFooterSpacingOptions
): DialogPassThroughOptions {
  const cn = footerClassName(options?.department);
  const top = options?.footerPaddingTop;

  if (!pt) {
    return { footer: mergeFooterPt(cn, top, undefined) };
  }

  return {
    ...pt,
    footer: mergeFooterPt(cn, top, pt.footer)
  };
}
